// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\Billing\PastExportsViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Bill, BillData, BillOptions } from 'data/models/Bill';
import { BillingSystem, BillingSystemData, BillingSystemOptions } from 'data/models/BillingSystem';
import { PastExportsBill as _PastExportsBill, PastExportsBillData as _PastExportsBillData, PastExportsBillOptions as _PastExportsBillOptions } from 'data/models/PastExportsResponse';

// PastExportsResponseData is the class that PastExportsResponse serializes to/from
export interface PastExportsResponseData {
    From : /* ISO8601 */ string;
    Id : number;
    To : /* ISO8601 */ string;
	
    BillingSystem : BillingSystemData | null;
    Bills : _PastExportsBillData[] | null;
	
}

// PastExportsResponseOptions is the class which may be passed to the PastExportsResponse constructor to define optional initial data values
export interface PastExportsResponseOptions {
    From : /* ISO8601 */ string;
    Id : number;
    To : /* ISO8601 */ string;
	
    BillingSystem? : BillingSystemOptions | null;
    Bills? : _PastExportsBillOptions[] | null;
	
}

export class PastExportsResponse {
    public From : DataSignal<TZDate>;
    public Id : DataSignal<number>;
    public To : DataSignal<TZDate>;
	
    public BillingSystem : DataSignal<BillingSystem | null>;
    public Bills : SDataArray<_PastExportsBill>;
	

    constructor();
    constructor(data : PastExportsResponseOptions);
    constructor(data: PastExportsResponseOptions | null = null) {
        this.From = jsonableObservable(S.value<TZDate>(data && data.From !== undefined ? new TZDate(data.From) : new TZDate(0), TZDate.eq));
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.To = jsonableObservable(S.value<TZDate>(data && data.To !== undefined ? new TZDate(data.To) : new TZDate(0), TZDate.eq));
	    
        this.BillingSystem = S.value<BillingSystem | null>(null);
        this.Bills = SArray<_PastExportsBill>([]);
	    
    }

    static key(obj : PastExportsResponse) {
        return obj.From().toJSON() + '\u2618' + obj.Id() + '\u2618' + obj.To().toJSON();
    }
    
    static dataKey(obj : PastExportsResponseOptions) {
        return new TZDate(obj.From).toJSON() + '\u2618' + obj.Id + '\u2618' + new TZDate(obj.To).toJSON();
    }

    static update(obj : PastExportsResponse, data : PastExportsResponseOptions) {
        S.freeze(() => {
            if (data.From !== undefined) obj.From(new TZDate(data.From));
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.To !== undefined) obj.To(new TZDate(data.To));
	        
	        
        });
    }
}

// PastExportsBillData is the class that PastExportsBill serializes to/from
export interface PastExportsBillData {
    Id : number;
	
    Bill : BillData | null;
	
    LastExportDate : /* ISO8601 */ string | null;
}

// PastExportsBillOptions is the class which may be passed to the PastExportsBill constructor to define optional initial data values
export interface PastExportsBillOptions {
    Id : number;
	
    Bill? : BillOptions | null;
	
    LastExportDate? : /* ISO8601 */ string | null;
}

export class PastExportsBill {
    public Id : DataSignal<number>;
	
    public Bill : DataSignal<Bill | null>;
	
    public LastExportDate : DataSignal<TZDate | null>;

    constructor();
    constructor(data : PastExportsBillOptions);
    constructor(data: PastExportsBillOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Bill = S.value<Bill | null>(null);
	    
        this.LastExportDate = jsonableObservable(S.value<TZDate | null>(data && data.LastExportDate !== undefined ? data.LastExportDate === null ? null : new TZDate(data.LastExportDate) : null, TZDate.nullableEq));
    }

    static key(obj : PastExportsBill) {
        return obj.Id();
    }
    
    static dataKey(obj : PastExportsBillOptions) {
        return obj.Id;
    }

    static update(obj : PastExportsBill, data : PastExportsBillOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.LastExportDate !== undefined) obj.LastExportDate(data.LastExportDate === null ? null : new TZDate(data.LastExportDate));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PastExportsResponse.ts